import React, { Component } from 'react'
import Popular from './Popular'
import { BrowserRouter as Router, Route, Link, Switch }from 'react-router-dom'
import styles from '../index.css'
import Nav from './Nav.js'
import Battle from './Battle.js'
import Home from './Home.js'
import Results from './Results.js'

class App extends Component {

  render() {
    return (
      <Router>
        <div className={styles.container} >
          <Nav />
          <Switch> 
            <Route exact path={'/'} component={Home} /> 
            <Route exact path={'/popular'} component={Popular} /> 
            <Route path='/battle/results' component={Results} />
            <Route path={'/battle'} component={Battle} /> 
            <Route render={function() {
              return (
                <p>Not Found</p>
              )
            }
            }/>
        </Switch>
      </div>
    </Router>
    ) 
  }
}

module.exports = App



// WEBPACK FOOTER //
// ./app/components/App.js